import { Component, OnInit } from "@angular/core";

import { FleetTrackerService } from "src/app/fleet-tracker.service";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["./dashboard.component.scss"]
})
export class DashboardComponent implements OnInit {

	constructor(private fleettracker: FleetTrackerService) { }

	ngOnInit() {
		this.fleettracker.Refresh();
	}

}
